// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__3leOp","widget_stretch":"Widget_widget_stretch__39-jM","content":"Widget_content__gXkMA"};